export default __webpack_public_path__ + "static/media/filter_user_role_light.0ca2bfed.svg";